import React from "react";
import Banner from "../components/banner/banner";
import PartnerSection from "../components/PartnerSection/partner";
import ROI from "../components/ROISection/ROI";
import UseCases from "../components/UseCasesSection/UseCases";
import FooterSection from "../components/FooterSection/footer";
import SecondBanner from "../components/SecondBannerSection/SecondBanner";
import SolutionSection from "../components/SolutionSection/SolutionSection";
import Features from "../components/Features/Features";
import Benefits from "../components/BenefitsSection/BenefitsSection";
import FAQ from "../components/FAQSection/FAQ";
export default function AgentSearch() {
  return (
    <>
      <Banner />
      <PartnerSection />
      <SolutionSection />
      <ROI />
      <UseCases />
      <Features />
      <Benefits />
      <FAQ />
      <SecondBanner />
      <FooterSection />
    </>
  );
}
